import { render, staticRenderFns } from "./StepUpOption.vue?vue&type=template&id=cd485526&scoped=true&"
import script from "./StepUpOption.vue?vue&type=script&lang=ts&"
export * from "./StepUpOption.vue?vue&type=script&lang=ts&"
import style0 from "./StepUpOption.vue?vue&type=style&index=0&id=cd485526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd485526",
  null
  
)

export default component.exports